/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const planIntervalSchema = z.enum(['monthly', 'yearly'])

export type PlanIntervalSchema = z.infer<typeof planIntervalSchema>
